import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { DialogConfig } from '../../../../../utilities/dialog-service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-lt-confirmation-dialog',
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './lt-confirmation-dialog.html',
  styleUrl: './lt-confirmation-dialog.scss',
  standalone: true,
})
export class LTConfirmationDialogComponent {
  data = inject<DialogConfig>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<LTConfirmationDialogComponent>);

  getDialogIcon(): string {
    switch (this.data.severity) {
      case 'info': return 'info';
      case 'warn': return 'warning';
      case 'error': return 'error';
      case 'success': return 'check_circle';
      default: return 'help';
    }
  }

  getIconColor(): string {
    switch (this.data.severity) {
      case 'info': return 'primary';
      case 'warn': return 'accent';
      case 'error': return 'warn';
      case 'success': return 'primary';
      default: return '';
    }
  }

  getConfirmIcon(): string {
    switch (this.data.severity) {
      case 'error': return 'delete';
      case 'warn': return 'warning';
      case 'success': return 'check';
      default: return 'check';
    }
  }

  getConfirmButtonColor(): string {
    switch (this.data.severity) {
      case 'error': return 'warn';
      case 'warn': return 'accent';
      case 'success': return 'primary';
      default: return 'primary';
    }
  }
}
